import { render } from "./odn-badge.vue?vue&type=template&id=a179b5b4"
import script from "./odn-badge.vue?vue&type=script&lang=js"
export * from "./odn-badge.vue?vue&type=script&lang=js"

import "./odn-badge.vue?vue&type=style&index=0&id=a179b5b4&lang=scss"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__